




























































import { Component, Vue } from 'vue-property-decorator';
import { zyScreenServer } from '@/api/installServer';
import ListDialog from '../../yunnanDataView/unit/box1/box-1-unit-2.vue';

@Component({
  components: { ListDialog },
})
export default class DataBox5 extends Vue {
  private formData: any = {
    overdueFinishTotal: 0,
    scheduledFinishTotal: 0,
    unFinishTotal: 0,
    waitFinishTotal: 0,
    productionUnitProfessionRate: 0,
  };

  private searchForm: any = {};

  mounted() {
    // this.getData({});
  }

  clickNum(type: any) {
    const ref: any = this.$refs['ListDialogRef'];
    const data: any = {
      totalType: type,
      deptId: this.searchForm.deptId || null,
    };
    ref.showDialog(data);
  }

  getData(opts: any) {
    this.searchForm = opts;
    zyScreenServer
      .getProfession({
        year: new Date().getFullYear(),
        deptId: opts.deptId || null,
      })
      .then((res: any) => {
        if (res.data) {
          this.formData.scheduledFinishTotal = res.data.block2.scheduledFinishTotal;
          this.formData.overdueFinishTotal = res.data.block2.overdueFinishTotal;
          this.formData.unFinishTotal = res.data.block2.unFinishTotal;
          this.formData.waitFinishTotal = res.data.block2.waitFinishTotal;
          this.formData.productionUnitProfessionRate = res.data.block3.productionUnitProfessionRate;
        }
      })
      .catch((e: any) => {
        console.log(e);
      });
  }
}
